import * as React from 'react';

function Maintenance() {
    const today = new Date()

    const startDay = "2026/06/15"
    const endDay = "2026/07/22"

    let isAfterOfStart = false;
    let isBeforeOfEnd = false;


    try {
        let todayYear = today.getFullYear();
        let todayMonth = today.getMonth() + 1;
        let todayDate = today.getDate();

        let todayMonth_str = ""
        if (todayMonth < 10) {
            todayMonth_str = "0" + String(todayMonth);
        } else {
            todayMonth_str = String(todayMonth);
        }

        let todayDate_str = ""
        if (todayDate < 10) {
            todayDate_str = "0" + String(todayDate);
        } else {
            todayDate_str = String(todayDate);
        }

        const today_int = parseInt(String(todayYear) + todayMonth_str + todayDate_str);

        const startDay_int = parseInt(startDay.replaceAll("/", ""));
        if (startDay_int <= today_int) {
            isAfterOfStart = true;
        }

        const endDay_int = parseInt(endDay.replaceAll("/", ""));
        if (endDay_int >= today_int) {
            isBeforeOfEnd = true;
        }
    } catch (e) {
        ;
    }

    if (isAfterOfStart & isBeforeOfEnd) {
        return (
            <>
                <div class="mod-box-02">
                    <div class="mod-txt align-center">
                        弊社ではシステムメンテナンス実施のため、以下の日時はシステムをご利用いただけません。<br />
                        <br />
                        停止日時：2026年7月23日（木） 19:00～22:00<br />
                        <br />
                        上記時間帯は、ログイン、お問い合わせ(新規)、お問い合わせ(継続/状況確認)を含む<br />
                        すべての機能がご利用いただけません。<br />
                        また、メンテナンス開始直前にお問い合わせの登録やファイルアップロードを行われた場合、<br />
                        処理が途中で中断される可能性がございますので、あらかじめご了承ください。<br />
                        <br />
                        なお、作業状況により、終了時刻が予告なく延長となる場合がございます。<br />
                        何卒よろしくお願いいたします。
                    </div>
                </div>
            </>
        );
    }

    return ( <></> )

}

export default Maintenance;